import GiftingEventAddonItemsPurchaseSelector from './GiftingEventAddonItemsPurchaseSelector';

export default GiftingEventAddonItemsPurchaseSelector;
